<template>
	<div class="paper">
		<div class="fixation">
			<div class="search">
				<div class="search-box">
					<div class="search-input">
						<input type="text" placeholder="请检单描述问题或关键词" v-model="keyword" @keydown.enter="keydown">
					</div>
					<div class="search-button">
						<button @click="fetchList()">
							<i class="el-icon-search"></i>
						</button>
					</div>
				</div>
			</div>
			<div class="content">
				<div class="category">
					<div class="category-title">
						<img src="../../../assets/paper-1.png" alt="" v-if="path == '/paper'">
						<img src="../../../assets/paper-2.png" alt="" v-if="path == '/guide'">
					</div>
					<ul>
						<li :class="categoryIndex == index ? 'category-current':''" v-for="(item,index) in category"
							:key="index" @click="useCategory(item,index)">
							{{item.name}}
						</li>
					</ul>
				</div>
				<div class="list">
					<div class="bread">
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
							<el-breadcrumb-item><span
									v-if="category.length>0">{{category[categoryIndex]['name']}}</span>
							</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
					<div class="flow" v-if="list.length>0">
						<li v-for="(item,index) in list" :key="index">
							<router-link
								:to="{path:'/essay',query:{id:item.articleId, category:category[categoryIndex]['name']}}">
								<div class="point">
									<span></span>
								</div>
								<div class="title">
									{{item.articleName}}
								</div>
								<div class="date">
									{{item.createAt}}
								</div>
							</router-link>
						</li>
					</div>
					<div class="pager" v-if="list.length>0">
						<el-pagination background layout="total, prev, pager, next, jumper" :total="total"
							:pager-count="11" :page-size="pageSize" :current-page="currentPage"
							@current-change="pageChange">
						</el-pagination>
					</div>
					<div class="empty" v-if="list.length==0">
						<el-empty></el-empty>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'paper',
		data() {
			return {
				keyword: '',
				id: '',
				category: [],
				categoryIndex: 0,
				categoryName: '',
				list: [],
				total: 100,
				currentPage: 1,
				pageSize: 12,
				path: ''
			};
		},
		watch: {
			$route(to, from) {
				let path = to.path
				this.disposeRouter(path)
			}
		},
		methods: {
			pageChange(e) {
				this.currentPage = e
				this.fetchList()
			},
			disposeRouter(path) {
				this.path = path
				this.keyword = ''
				this.fetchData()
			},
			fetchData() {
				this.$api.frontArticleType({}, res => {
					let list = res.data
					let array = new Array()
					let type = this.path == '/paper' ? 2 : 1
					for (let i = 0; i < list.length; i++) {
						if (list[i]['parentId'] == type) {
							array.push({
								id: list[i]['articleTypeId'],
								name: list[i]['articleTypeName']
							})
						}
					}
					this.category = array
					sessionStorage.setItem('category', JSON.stringify(array))
					this.fetchList()
				})
			},
			fetchList() {
				this.$api.frontArticleList({
					pageSize: this.pageSize,
					pageNum: this.currentPage,
					keyword: this.keyword,
					articleOneType: this.path == '/paper' ? 2 : 1,
					articleTwoType: this.category.length > 0 ? this.category[this.categoryIndex]['id'] : '',
					articleName: this.keyword
				}, res => {
					if (res.code == 200) {
						this.total = res.data.total
						this.list = res.data.list
					}
				})
			},
			useCategory(item, index) {
				this.categoryIndex = index
				this.fetchList()
			},
			keydown() {
				this.fetchList()
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.path = this.$route.path
			this.disposeRouter(this.path)
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.paper {
		width: 100%;
		background: @vue-bg-color-grey;
		padding: @vue-spacing-col-lg 0px;
		box-sizing: border-box;

		.search {
			width: 100%;
			height: 100px;
			padding-left: 250px;
			box-sizing: border-box;
			display: flex;
			align-items: center;

			.search-box {
				width: 100%;
				height: 45px;

				display: flex;
				justify-content: space-between;

				.search-input {
					width: calc(100% - 120px);
					height: 100%;
					border: 2px solid @vue-border-color;
					box-sizing: border-box;
					border-radius: @vue-border-radius-base 0px 0px @vue-border-radius-base;
					overflow: hidden;
					border-right: none;

					input {
						width: 100%;
						height: 100%;
						display: block;
						border: none;
						padding-left: @vue-spacing-row-base;
						box-sizing: border-box;
						outline: none;
					}
				}

				.search-button {
					width: 120px;
					height: 100%;

					button {
						width: 100%;
						height: 100%;
						border: none;
						font-size: @vue-font-size-base;
						background: @vue-bg-color-red;
						color: @vue-text-color-inverse;
						border-radius: 0px @vue-border-radius-base @vue-border-radius-base 0px;
					}
				}
			}
		}

		.content {
			width: 100%;
			display: flex;
			justify-content: space-between;

			.category {
				width: 220px;

				.category-title,
				li {
					width: 100%;
					height: 50px;
					display: flex;
					justify-content: center;
					align-items: center;
					font-size: @vue-font-size-sm - 2;
				}

				.category-title {
					background: #3d3d3d;
				}

				li {
					background: #eaeaea;
					border-bottom: 2px solid #f5f5f5;
					cursor: pointer;
				}

				.category-current {
					border-left: 2px solid @vue-border-color-red;
					color: @vue-text-color-red;
					box-sizing: border-box;
				}
			}

			.list {
				width: calc(100% - 250px);
				background: @vue-bg-color;
				padding: @vue-spacing-col-base @vue-spacing-row-base;
				box-sizing: border-box;

				.bread {
					width: 100%;
					height: 50px;
					border-bottom: 1px solid @vue-border-color;
					display: flex;
					align-items: center;
					padding-left: @vue-spacing-row-base;
					box-sizing: border-box;
				}

				.flow {
					width: 100%;
					padding: @vue-spacing-col-base 0px @vue-spacing-col-lg 0px;

					li {
						width: 100%;
						height: 40px;

						a {
							width: 100%;
							height: 100%;
							display: flex;
							color: @vue-text-color;
							font-size: @vue-font-size-sm - 2;

							.point {
								width: 40px;
								height: 100%;
								display: flex;
								justify-content: center;
								align-items: center;

								span {
									width: 8px;
									height: 8px;
									border-radius: @vue-border-radius-circle;
									background: @vue-bg-color-red;
								}
							}

							.title {
								width: calc(100% - 200px);
								height: 100%;
								display: flex;
								align-items: center;
							}

							.date {
								width: 160px;
								height: 100%;
								display: flex;
								align-items: center;
								justify-content: flex-end;
							}
						}
					}
				}

				.pager {
					width: 100%;
					height: 70px;
					display: flex;
					justify-content: flex-end;
					align-items: center;
				}
			}
		}
	}
</style>
